import dayjs from "dayjs";

export const RATE_LOOKUP_DURATIONS = ["journee", "semaine", "annee"];

export const PARTNER_TARIFF_KEY = "PARTNER";

export const toRateLookupForm = (prices = {}) => {
  const rates = prices.rates || {};
  return RATE_LOOKUP_DURATIONS.reduce((acc, duration) => {
    acc[duration] = {
      public: rates[duration],
      partner: rates[`${duration}|${PARTNER_TARIFF_KEY}`],
    };
    return acc;
  }, {});
};

export const toRateLookupPrices = (form = {}, existing = {}) => {
  const rates = RATE_LOOKUP_DURATIONS.reduce((acc, duration) => {
    const row = form[duration] || {};
    acc[duration] = Number(row.public);
    acc[`${duration}|${PARTNER_TARIFF_KEY}`] = Number(row.partner);
    return acc;
  }, {});
  const next = {
    ...existing,
    rates,
  };
  if (next.aggregator === undefined) {
    delete next.aggregator;
  }
  return next;
};

export const toPricerDateForm = (pricer) => {
  const source = pricer || {};
  const start = source.startDate ? dayjs(source.startDate) : null;
  const end = source.endDate ? dayjs(source.endDate) : null;
  if (!start && !end) {
    return [];
  }
  return [start, end];
};

export const toPricerDatePayload = (dates) => {
  const start = dates && dates[0];
  const end = dates && dates[1];
  return {
    startDate:
      start && start.startOf
        ? start.startOf("day").toISOString()
        : start || null,
    endDate: end && end.endOf ? end.endOf("day").toISOString() : end || null,
  };
};
